import React, { useState, useContext } from "react";
import { Pagination, Select } from "antd";
import { useQuery, useQueryClient } from "react-query";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { userContext } from "../../../context/UserContextProvider";
import SearchFilter from "../../SearchFilter";
import OtherContactTable from "./OtherContactTable";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const OtherContactList = () => {
  const { t } = useTranslation();
  const { currentPage, setCurrentPage, limit, setLimit, total, setTotal } = useContext(userContext);
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const [searchKeyword, setSearchKeyword] = useState("");

  const fetchContacts = async () => {
    const response = await axiosInstance.get(
      `api/directory/other-contacts?page=${currentPage}&limit=${limit}`
    );
    setTotal(response.data.data.totalPages);
    return response;
  };

  const contactsQuery = useQuery(["other-contacts", currentPage, limit], fetchContacts);
  const fetchSearchResults = async () => {
    if (searchKeyword) {
      const res = await axiosInstance.get(
        `api/directory/searchOC?keyword=${searchKeyword}&page=${currentPage}&limit=${limit}`
      );
      setTotal(res?.data?.totalpages);
      return res;
    } else {
      return fetchContacts();
    }
  };

  const searchResults = useQuery(
    ["other-contacts-search", searchKeyword, currentPage, limit],
    fetchSearchResults,
    { refetchOnWindowFocus: false }
  );

  const handleSearch = (val) => {
    setCurrentPage(1);
    setSearchKeyword(val);
  };

  const handleDelete = async (record) => {
    try {
      const res = await axiosInstance.delete(`/api/directory/other-contacts/${record._id}`);
      toast.success(res.data.message);
      queryClient.invalidateQueries("other-contacts");
      queryClient.invalidateQueries("other-contacts-search");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error deleting contact");
    }
  };
  
  return (
    <>
      <SearchFilter handleSearch={handleSearch} />
      {/* {contactsQuery?.data?.data?.data?.results?.length === 0 && (<h1>No data available</h1>)} */}
       {/* {contactsQuery?.data?.data?.data?.results?.length !== 0 &&  */}
       <OtherContactTable
        membersData={contactsQuery?.data?.data?.data?.results || []}
        searchResults={searchResults?.data?.data?.data || []}
        handleDelete={handleDelete}
        searchKeyword={searchKeyword}
      />
      {/* } */}
      <div className="client-pagination mx-5">
        <div className="pagination-text">
          {t("Showing")}
          <Select
            className="mx-2"
            value={limit.toString()}
            style={{ width: 56 }}
            onChange={(val) => {
              setLimit(parseInt(val));
              setCurrentPage(1);
            }}
            options={[
              { value: "10", label: "10" },
              { value: "20", label: "20" },
              { value: "50", label: "50" },
              { value: "100", label: "100" }
            ]}
          />
          {t("Entries per page")}
        </div>
        <Pagination
          current={currentPage}
          pageSize={limit}
          total={total * limit}
          onChange={(page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize);
          }}
          className="pagination"
        />
      </div>
    </>
  );
};

export default OtherContactList;
